import {
  Component,
  input,
  output,
  ChangeDetectionStrategy
} from '@angular/core';
import { PerformanceBannerConfig } from '@ui/shared/model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-performance-warning-banner',
  templateUrl: './performance-warning-banner.component.html',
  styleUrls: ['./performance-warning-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe]
})
export class PerformanceWarningBannerComponent {
  readonly confirmed = input<boolean>(undefined);
  readonly config = input<PerformanceBannerConfig>(undefined);
  readonly confirm = output<void>();

  onClose() {
    this.confirm.emit();
  }
}
